const backfillCurrenciesFix = async (db: IDBDatabase) => {
  const tx = db.transaction(
    ["invoices", "pendingInvoices", "products"],
    "readwrite"
  );

  // backfill currencies fix for invoices
  const invoicesObjectStore = tx.objectStore("invoices");
  const invoiceRequest = invoicesObjectStore.openCursor();
  await new Promise((resolve, reject) => {
    invoiceRequest.onsuccess = (event) => {
      const cursor = (event.target as any).result as IDBCursorWithValue;

      if (cursor) {
        const invoice = cursor.value;

        // update invoice products
        const salesInvoiceProducts = invoice.salesInvoiceProducts.data.map(
          (product: any) => ({
            productId: product.productId,
            quantity: product.quantity,
            description: product?.description,
            originalUnitPrice:
              product.originalPriceSubtotal / product.quantity / 100,
            actualUnitPrice:
              product.actualPriceSubtotal / product.quantity / 100,
            taxPercent: product.taxPercent,
            taxIsIncluded: false,
          })
        );

        // update invoice receipt usages
        const salesReceiptInvoiceUsages =
          invoice.salesReceiptInvoiceUsages?.data.map((usage: any) => ({
            ...usage,
            amount: usage.amount / 100,
            actualPaidAmount: usage.actualPaidAmount / 100,
            salesReceipt:
              usage?.salesReceipt?.data != null
                ? {
                    ...usage.salesReceipt.data,
                    amount: usage.salesReceipt.data.amount / 100,
                    costSubtotal:
                      ((usage.salesReceipt.data as any)?.costSubtotal || 0) /
                      100,
                    taxSubtotal:
                      ((usage.salesReceipt.data as any)?.taxSubtotal || 0) /
                      100,
                  }
                : undefined,
          }));

        cursor.update({
          orgId: invoice.orgId,
          posId: invoice.posId,

          createdAt: invoice.createdAt,
          issueDate: invoice.issueDate,
          dueDate: invoice.dueDate,

          reference: invoice.reference,
          isCash: invoice.isCash,
          type: "simple",
          customerId: invoice.customerId,

          isAnonymousCustomer: invoice.isAnonymousCustomer,
          callNumber: invoice?.callNumber,
          memberId: invoice?.memberId,
          isNotSynced: false,
          salesInvoiceProducts: salesInvoiceProducts,
          salesReceiptInvoiceUsages: salesReceiptInvoiceUsages ?? undefined,
        });
        cursor.continue();
      } else {
        resolve(null);
      }
    };

    invoiceRequest.onerror = () => {
      reject(new Error("Failed to iterate over invoices"));
    };
  });

  // backfill currencies fix for pending invoices
  const pendingInvoicesObjectStore = tx.objectStore("pendingInvoices");
  const pendingInvoiceRequest = pendingInvoicesObjectStore.openCursor();
  await new Promise((resolve, reject) => {
    pendingInvoiceRequest.onsuccess = (event) => {
      const cursor = (event.target as any).result as IDBCursorWithValue;

      if (cursor) {
        const invoice = cursor.value;

        // update invoice products
        const salesInvoiceProducts = invoice.salesInvoiceProducts.data.map(
          (product: any) => ({
            productId: product.productId,
            quantity: product.quantity,
            description: product?.description,
            originalUnitPrice:
              product.originalPriceSubtotal / product.quantity / 100,
            actualUnitPrice:
              product.actualPriceSubtotal / product.quantity / 100,
            taxPercent: product.taxPercent,
            taxIsIncluded: false,
          })
        );

        // update invoice receipt usages
        const salesReceiptInvoiceUsages =
          invoice.salesReceiptInvoiceUsages?.data.map((usage: any) => ({
            ...usage,
            amount: usage.amount / 100,
            actualPaidAmount: usage.actualPaidAmount / 100,
            salesReceipt:
              usage?.salesReceipt?.data != null
                ? {
                    ...usage.salesReceipt.data,
                    amount: usage.salesReceipt.data.amount / 100,
                    costSubtotal:
                      ((usage.salesReceipt.data as any)?.costSubtotal || 0) /
                      100,
                    taxSubtotal:
                      ((usage.salesReceipt.data as any)?.taxSubtotal || 0) /
                      100,
                  }
                : undefined,
          }));

        cursor.update({
          orgId: invoice.orgId,
          posId: invoice.posId,

          createdAt: invoice.createdAt,
          issueDate: invoice.issueDate,
          dueDate: invoice.dueDate,

          reference: invoice.reference,
          isCash: invoice.isCash,
          type: "simple",
          customerId: invoice.customerId,

          isAnonymousCustomer: invoice.isAnonymousCustomer,
          callNumber: invoice?.callNumber,
          memberId: invoice?.memberId,
          isNotSynced: true,

          salesInvoiceProducts: salesInvoiceProducts,
          salesReceiptInvoiceUsages: salesReceiptInvoiceUsages ?? undefined,
        });
        cursor.continue();
      } else {
        resolve(null);
      }
    };

    pendingInvoiceRequest.onerror = () => {
      reject(new Error("Failed to iterate over pending invoices"));
    };
  });

  // fix currencies for products
  const productsObjectStore = tx.objectStore("products");
  const productRequest = productsObjectStore.openCursor();

  await new Promise((resolve, reject) => {
    productRequest.onsuccess = (event) => {
      const cursor = (event.target as any).result as IDBCursorWithValue;

      if (cursor) {
        const product = cursor.value as ProductSchema;

        cursor.update({
          ...product,
          salePrice: (product.salePrice || 0) / 100,
          purchasePrice: (product.purchasePrice || 0) / 100,
        } as ProductSchema);

        cursor.continue();
      } else {
        resolve(null);
      }
    };

    productRequest.onerror = () => {
      reject(new Error("Failed to iterate over products"));
    };
  });
};

export default backfillCurrenciesFix;
